import BaseServiceCrud from './BaseServiceCrud';

export default class StatisticService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'statistics';
    }

    getKilometersTraveledMonth() {
        return this.fetch(`${this.domain}/${this.path}/month/kilometers-traveled`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getSavedCo2Month() {
        return this.fetch(`${this.domain}/${this.path}/month/savedCo2`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getFinishedChallengesCountInMonth() {
        return this.fetch(`${this.domain}/${this.path}/month/finished-challenges-count`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getChartKilometersTraveledByMonth() {
        return this.fetch(`${this.domain}/${this.path}/month/chart/kilometers`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getChartSavedCo2ByMonth() {
        return this.fetch(`${this.domain}/${this.path}/month/chart/savedCo2`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getTodayCoordinates() {
        return this.fetch(`${this.domain}/${this.path}/day/coordinates`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
